/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_About_Sampleintro1Inputs */

const ja_playdata_about_sampleintro1 = /** @type {(inputs: Playdata_About_Sampleintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以下からサンプルレポートが閲覧可能です。`)
};

const en_playdata_about_sampleintro1 = /** @type {(inputs: Playdata_About_Sampleintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can download our free sample report below.`)
};

/**
* | output |
* | --- |
* | "You can download our free sample report below." |
*
* @param {Playdata_About_Sampleintro1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_about_sampleintro1 = /** @type {((inputs?: Playdata_About_Sampleintro1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_About_Sampleintro1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_about_sampleintro1(inputs)
	return en_playdata_about_sampleintro1(inputs)
});
export { playdata_about_sampleintro1 as "playdata_about_sampleIntro" }